import { httpClient } from '../base/httpClient';
import { User } from '../../types/auth';
import { PaginatedResponse } from '../../types/common';

interface UserFilters {
  page?: number;
  per_page?: number;
  search?: string;
  role?: 'super_admin' | 'admin' | 'user';
  is_active?: boolean;
}

class UserService {
  async getUsers(filters?: UserFilters): Promise<PaginatedResponse<User>> {
    const response = await httpClient.getClient().get('/users', { params: filters });
    return response.data;
  }

  async getUser(id: number): Promise<User> {
    const response = await httpClient.getClient().get(`/users/${id}`);
    return response.data.data;
  }
}

export const userService = new UserService();
export default userService;
